/* eslint-disable import/prefer-default-export */
import { INVALID_SCOPE } from './views/VAuthCallback.constants'

export class InvalidScopesError extends Error {
  constructor() {
    super(INVALID_SCOPE)
  }
}
